import {
    CHANGE_GENERAL_STORE_SETTINGS, CLOSE_ADMIN_BURGER_MENU, CLOSE_ARAG_USER_BURGER_MENU,
    CLOSE_ARAG_USER_SETTINGS_MENU, CLOSE_USER_BURGER_MENU, OPEN_ADMIN_BURGER_MENU,
    OPEN_ARAG_USER_BURGER_MENU,
    OPEN_ARAG_USER_SETTINGS_MENU, OPEN_SOLICITOR_USER_BURGER_MENU
} from "../actions";

const defaultState = {
    isSettingsMenuOpen: false,
    aragUserBurgerMenuOpen: false,
    userBurgerMenuOpen: false,
    adminBurgerMenuOpen: false
};

export default (state = defaultState, action) => {
    switch (action.type){
        case OPEN_ADMIN_BURGER_MENU:
            return {
                ...state,
                adminBurgerMenuOpen: true
            };
        case CLOSE_ADMIN_BURGER_MENU:
            return {
                ...state,
                adminBurgerMenuOpen: false
            };
        case OPEN_SOLICITOR_USER_BURGER_MENU:
            return {
                ...state,
                userBurgerMenuOpen: true
            };
        case CLOSE_USER_BURGER_MENU: {
            return {
                ...state,
                userBurgerMenuOpen: false
            };
        }
        case OPEN_ARAG_USER_BURGER_MENU:
            return {
                ...state,
                aragUserBurgerMenuOpen: true
            };
        case CLOSE_ARAG_USER_BURGER_MENU:
            return {
                ...state,
                aragUserBurgerMenuOpen: false
            };
        case OPEN_ARAG_USER_SETTINGS_MENU:
            return {
                ...state,
                isSettingsMenuOpen: true
            };
        case CLOSE_ARAG_USER_SETTINGS_MENU:
            return {
                ...state,
                isSettingsMenuOpen: false
            };
        case CHANGE_GENERAL_STORE_SETTINGS:
            return {
                ...state,
                [action.payload.key]: action.payload.value
            };
        case '@@router/LOCATION_CHANGE':
            return {
                ...state,
                isSettingsMenuOpen: defaultState.isSettingsMenuOpen
            };
        default:
            return state
    }
}